// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, 
body, 
#ie4Fw5rm84FxcTecGr23 {
    height: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px;
    background-color: #DADADA;
}

.ZGkF9Aauuc7rQUvGAfic, 
.DOqvrmnAZBgKZ2HNF4gl {
    width: 100%;
}

.HeTbVS3teHRPE76sjHc5 { 
    background-color: 'inherit' 
}`, "",{"version":3,"sources":["webpack://./src/styles/globalStyles.module.css"],"names":[],"mappings":"AAAA;;;IAGI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI;AACJ","sourcesContent":["html, \nbody, \n#root {\n    height: 100%;\n    width: 100%;\n    margin: 0px;\n    padding: 0px;\n    background-color: #DADADA;\n}\n\n.mantine-AppShell-body, \n.mantine-AppShell-main {\n    width: 100%;\n}\n\n.mantine-Avatar-placeholder { \n    background-color: 'inherit' \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ie4Fw5rm84FxcTecGr23`,
	"mantine-AppShell-body": `ZGkF9Aauuc7rQUvGAfic`,
	"mantine-AppShell-main": `DOqvrmnAZBgKZ2HNF4gl`,
	"mantine-Avatar-placeholder": `HeTbVS3teHRPE76sjHc5`
};
export default ___CSS_LOADER_EXPORT___;
